<template>
<div>
  <el-button @click="check" size="small">检查全部公式</el-button>
  <el-dialog :visible.sync="hasResult" title="公式检查结果">
    <p v-for="(item, index) of result" :key="index">
      {{item}}
    </p>
  </el-dialog>
</div>
</template>

<script>
import { getProjectVirtual } from '@/api/virtual-controller'
import { getProjectDevices } from '@/api/device-controller'
import { removeSlash } from '@/utils/removeIdSlash.js'
import _ from 'lodash'

export default {
  name: 'verifyFormula',
  data () {
    return {
      hasResult: false,
      result: [],
      dList: new Map()
    }
  },
  async created () {
    const pId = removeSlash(this.$store.state.app.project.id.id)
    const list = await getProjectDevices(pId)
    for (const item of list.data.data) {
      const str = item.id.id
      const id = str.substring(15, 18) + str.substring(9, 13) + str.substring(0, 8) + str.substring(19, 23) + str.substring(24)
      if (item.name !== '默认网关') {
        this.dList.set(id, item.name)
      }
    }
  },
  methods: {
    async check () {
      this.result = []
      let vtList = await getProjectVirtual(this.$store.state.app.project.id.id)
      vtList = vtList.data
      const serialNumbers = vtList.map(vt => vt.serialNumber)
      const removeDuplicateSerialNumbers = _.uniq(serialNumbers)
      if (serialNumbers.length > removeDuplicateSerialNumbers.length) {
        this.result.push('有重复虚拟公式编号')
      }
      vtList = vtList.filter(vt => vt.type === 'calculation')
      // const calcuationSerialNumbers = vtList.map(vt => vt.serialNumber)
      vtList.map(vt => {
        if (typeof vt.formula === 'undefined' || vt.formula === null) {
          console.log('no formula')
          this.result.push('虚拟表：' + vt.name + '没有公式')
          return 0
        }
        const usedSerialNumber = []
        const meterRegex = /^[a-zA-Z](\d)+$/
        const splitOperator = /([\+\-\*\/\(\)])/
        const layer1 = vt.formula.split(splitOperator)
        const layer2 = layer1.filter(item => item.length > 0)
        // layer2.map(item => {
        // })
        for (const item of layer2) {
          if (meterRegex.test(item)) {
            usedSerialNumber.push(item)
          }
          if (item.includes('.') && item.split('.')[0].length === 31) {
            if (this.dList.get(item.split('.')[0])) {
              //
            } else {
              this.result.push('公式：' + vt.name + ' 中,存在无效设备')
            }
          }
        }
        console.log(layer2, '-------')
        const resultArray = _.intersection(usedSerialNumber, removeDuplicateSerialNumbers)
        const lostArray = usedSerialNumber.filter(item => !resultArray.includes(item))
        // console.log('in' + vt.name + ' lost' + lostArray)
        if (lostArray.length > 0) {
          this.result.push('公式：' + vt.name + ' 中 ' + lostArray + ' 引用无效')
        }
      })
      if (this.result === '') {
        this.$message('无重复虚拟公式编号，无效依赖以及空公式')
      } else {
        this.result.length > 0 ? this.hasResult = true : this.$message('未检出错误')
        // this.hasResult = true
      }
    }
  }
}
</script>
